import React from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import moment from 'moment';
import Cell from './Cell';
import DisabledCell from '../../shared/tableCells/DisabledCell';
import EmployeeCell from '../../shared/tableCells/EmployeeCell';
import '../../shared/Table.css';

const Row = ({
  employee,
  createScheduleForEmployee,
  datesInWeek,
  schedules,
  editSchedule,
  copySelectedShift,
  deleteSelectedShift,
  timeOffRequests
}) => {
  const formatDateForSchedulesKey = date => moment(date).format('YYYY-MM-DD');
  const getScheduleForDate = date => (schedules && schedules[formatDateForSchedulesKey(date)]) ? schedules[formatDateForSchedulesKey(date)] : [];
  const calculateHoursForWeek = () => {
    let shiftsInWeek = [];

    datesInWeek.forEach(date => {
      const scheduleForDate = getScheduleForDate(date);
      shiftsInWeek.push(...scheduleForDate);
    });

    const minutesWorked = shiftsInWeek.reduce((accumulator, currentValue) => {
      const { start, end, breakMinutes } = currentValue;

      return accumulator + (moment(end).diff(moment(start), 'minutes') - breakMinutes);
    }, 0);

    return parseFloat(minutesWorked / 60).toFixed(2);
  };

  // called by child component to get the shift, then pass that shift and employee up to the parent
  const handleEditSchedule = selectedShift => editSchedule(employee, selectedShift);

  const groupTimeOffRequestsByDate = () => {
    let obj = {};

    if (timeOffRequests) {
      timeOffRequests.forEach(req => {
        const { start } = req;
        const formatted = moment(start).format('YYYY-MM-DD');

        if (obj[formatted] === undefined) {
          obj[formatted] = [req];
        } else {
          obj[formatted].push(req);
        }
      });
    }

    return obj;
  };

  const grouped = groupTimeOffRequestsByDate();

  return (
    <TableRow className='schedulingRow'>
      <EmployeeCell profileImage={employee.image} name={employee.name} />
      { datesInWeek.map((date, index) => {
        const timeOffForDate = grouped[formatDateForSchedulesKey(date)];
        const hasTimeOffOnDate = timeOffForDate && timeOffForDate.length > 0;
        const hasApprovedTimeOff = hasTimeOffOnDate ? timeOffForDate.filter(i => i.status && i.status.status === 'approve').length > 0 : false;
        const allDayApprovedTimeOffRequest = hasApprovedTimeOff && timeOffForDate.filter(i => i.allDay).length > 0;

        if (hasApprovedTimeOff && allDayApprovedTimeOffRequest) {
          return (
            <DisabledCell key={index} />
          );
        }

        return (
          <Cell
            key={index}
            date={date}
            schedule={getScheduleForDate(date)}
            onCreateSchedule={() => createScheduleForEmployee(employee, date)}
            onEditSchedule={handleEditSchedule}
            onCopyShift={copySelectedShift}
            onDeleteShift={deleteSelectedShift}
            canPerformAction={moment(date).endOf('day').isAfter(moment())}
          />
        );
      })}
      <TableCell>
        <span>{calculateHoursForWeek()}</span>
      </TableCell>
    </TableRow>
  );
};

export default Row;
